import { jsx as _jsx } from "react/jsx-runtime";
import { useAetherContext } from '#pplx/frontend/aether/components/AetherProvider/useAetherContext.js';
import { DropdownMenu } from '#pplx/frontend/aether/components/DropdownMenu/index.js';
import { Tooltip } from '#pplx/frontend/aether/components/Tooltip/index.js';
import { IconPrimitive } from '#pplx/frontend/aether/primitives/IconPrimitive/index.js';
import { AskInputFileUploadUpsellPopover } from '#pplx/frontend/apps/ask/ask-input/ask-input-upsell-popover/components/AskInputFileUploadUpsellPopover.js';
import { PLUS_MENU_ITEM_SELECTED_EVENT_NAME, plusMenuItemSelectedEvent, } from '#pplx/frontend/apps/ask/events/ask-input-plus-menu/analytics.js';
import { uploadFilesOrImagesMessage } from '#pplx/frontend/apps/ask/hooks/file-attachments-hooks/fileAttachmentMessages.js';
import { runFileMenuAction } from '#pplx/frontend/composer-sdk-plugins/file-attachments/runFileMenuAction.js';
import { useInstrumentation } from '#pplx/frontend/framework/instrumentation/useInstrumentation.js';
import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
import { useWebPlatform } from '#pplx/frontend/platform-components/useWebPlatform.js';
import React, { useCallback, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
export const AskInputPlusMenuFileUpload = React.memo(function AskInputPlusMenuFileUpload({ gateUploadFile, canUploadFile, fileRetentionMessage, fileMenuMessage = uploadFilesOrImagesMessage, onOpenFilePicker, tooltipMaxWidth, isNarrowSurface, }) {
    const { track } = useInstrumentation();
    const { device: { isMacOS, isWindowsOS }, } = useWebPlatform();
    const { isMobileUserAgent, isMobileStyle } = useAetherContext();
    const shouldShowInlineRetentionMessage = isNarrowSurface || !!import.meta.env.VITE_IS_SIDECAR_BUILD;
    const shouldShowRetentionMessage = fileRetentionMessage !== undefined;
    const isGated = !canUploadFile.canUpload;
    const handleOnSelect = useCallback(() => {
        runFileMenuAction({
            gate: () => Boolean(gateUploadFile('local')),
            onSelect: (gated) => {
                track(plusMenuItemSelectedEvent({
                    name: PLUS_MENU_ITEM_SELECTED_EVENT_NAME,
                    data: {
                        item: 'upload_files_or_images',
                        gated,
                    },
                }));
            },
            open: onOpenFilePicker,
        });
    }, [gateUploadFile, onOpenFilePicker, track]);
    const showShortcut = isMacOS || isWindowsOS;
    const trailingAccessory = useMemo(() => {
        if (isGated) {
            return (_jsx("span", { className: "text-secondary", children: _jsx(IconPrimitive, { icon: $icon('lock'), size: "inherit" }) }));
        }
        if (showShortcut) {
            return (_jsx("span", { className: "text-xs text-secondary opacity-0 transition-opacity group-hover/file-upload:opacity-100", children: isMacOS ? '⌘U' : 'Ctrl+U' }));
        }
        return null;
    }, [isGated, showShortcut, isMacOS]);
    const menuItem = (_jsx("div", { className: "group/file-upload", children: _jsx(DropdownMenu.Item, { onSelect: handleOnSelect, leadingAccessory: $icon('paperclip'), trailingAccessory: trailingAccessory, subtitle: shouldShowRetentionMessage && shouldShowInlineRetentionMessage
                ? fileRetentionMessage
                : undefined, children: _jsx("span", { className: isGated ? 'text-secondary group-hover/file-upload:text-primary transition-colors' : '', children: _jsx(FormattedMessage, { ...fileMenuMessage }) }) }) }));
    // The bottom sheet spans the viewport, so side tooltips and popovers would open off-screen.
    if (isMobileUserAgent || isMobileStyle) {
        return menuItem;
    }
    if (isGated) {
        return (_jsx(AskInputFileUploadUpsellPopover, { gateReason: canUploadFile.reason, onClick: handleOnSelect, children: menuItem }));
    }
    if (!shouldShowRetentionMessage || shouldShowInlineRetentionMessage) {
        return menuItem;
    }
    return (_jsx(Tooltip, { content: fileRetentionMessage, side: "right", maxWidthPx: tooltipMaxWidth, children: menuItem }));
});
//# sourceMappingURL=AskInputPlusMenuFileUpload.js.map